import { createContext, useContext, useEffect, useState } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('geoquest_token');

        if (token)
            api
                .get('/auth/me')
                .then((res) => setUser(res.data))
                .catch(() => localStorage.removeItem('geoquest_token'))
                .finally(() => setLoading(false));

        else setLoading(false);
    }, [])

    const login = (token, userData) => {
        localStorage.setItem('geoquest_token', token);

        setUser(userData);
    }

    const logout = () => {
        localStorage.removeItem('geoquest_token');

        setUser(null);
    }

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
